import { template as template_3778aebd456d4498bd9a4771415152a6 } from "@ember/template-compiler";
import { fn, get } from '@ember/helper';
import { service } from '@ember/service';
import BarcodeComponentOptions from 'eflex/constants/tasks/jem-barcode-component-options';
import Component from '@glimmer/component';
import { gt, or, and, not } from 'ember-truth-helpers';
import { selectVal } from 'eflex/helpers';
import { t } from 'ember-intl';
import BsTooltip from 'eflex/components/bs-tooltip';
import TrashCan from 'eflex/components/trash-can';
import QuantitySelect from 'eflex/components/quantity-select';
export default class TaskContextConfigBarcode extends Component {
    @service
    store;
    get currentPassThrough() {
        return BarcodeComponentOptions?.find((item)=>item.value === String(this.args.task.passThrough));
    }
    addMultipleStrings = (stringQuantity)=>{
        const task = this.args.task;
        const strings = task.strings;
        const store = this.store;
        const taskConfigs = task.taskConfigs;
        for(let i = 0; i < stringQuantity; i++){
            strings.push(store.createRecord('barcode-string', {}));
            taskConfigs.forEach((config)=>{
                config.strings.push(store.createRecord('barcode-string', {}));
            });
        }
    };
    removeString = (index)=>{
        const task = this.args.task;
        task.taskConfigs.forEach((config)=>{
            config.strings.splice(index, 1);
        });
        task.strings.splice(index, 1);
    };
    setPassThrough = (value)=>{
        this.args.task.passThrough = JSON.parse(value);
    };
    static{
        template_3778aebd456d4498bd9a4771415152a6(`
    {{#if (and @taskConfig.usesComponents (not @task.component.isAlwaysRun))}}
      <@form.element
        @controlType="radio-group"
        @inline={{true}}
        @property="currentPassThrough"
        @model={{this}}
        @options={{BarcodeComponentOptions}}
        @optionLabelPath="label"
        @onChange={{selectVal this.setPassThrough}}
        class="component-pass-through pb-2"
      as |el|>
        <el.control @inline={{true}} as |opt|>
          {{t opt}}
        </el.control>
      </@form.element>
    {{/if}}

    <div class="bootstrap-table">
      <div class="row header-row gx-2">
        <div class="col-icon model-specific border-0" />
        <div class="col">
          {{t "startChar"}}
        </div>
        <div class="col model-specific">
          {{t "plant.task.barcode.stringToRead"}}
        </div>
        <div class="col-icon border-0" />
      </div>
      {{#each @taskConfig.strings as |configString index|}}
        <div class="row form-row gx-2">
          <div class="col-icon model-specific col-enable">
            <@form.element
              @model={{configString}}
              @controlType="checkbox"
              @property="enabled"
              class="barcode-enabled"
            />
          </div>
          <div class="col">
            <@form.element
              @controlType="number"
              @model={{get @task.strings index}}
              @property="compareLocation"
            as |el|>
              <el.control
                disabled={{or @disabled configString.isRegex}}
                class="start-char form-control-sm"
              />
              {{#if configString.isRegex}}
                <BsTooltip
                  @title={{t "plant.task.barcodereader.startPositionNotUsed"}}
                  @triggerEvents="hover"
                />
              {{/if}}
            </@form.element>
          </div>
          <div class="col model-specific">
            {{#if @task.passThrough}}
              <@form.element @value={{t "componentPassThrough"}} as |el|>
                <el.control
                  class="barcode-string form-control-sm"
                  disabled={{true}}
                />
              </@form.element>
            {{else}}
              <@form.element
                @model={{configString}}
                @property="barcodeString"
              as |el|>
                <el.control class="barcode-string form-control-sm" />
              </@form.element>
            {{/if}}
          </div>
          <div class="col-icon">
            {{#if (gt @taskConfig.strings.length 1)}}
              <TrashCan
                disabled={{@disabled}}
                @onDelete={{fn this.removeString index}}
              />
            {{/if}}
          </div>
        </div>
      {{/each}}

      <div class="row mt-4">
        <div class="col-auto">
          <QuantitySelect
            class="text-uppercase"
            @disabled={{@disabled}}
            @max={{this.remainingStrings}}
            @onSubmit={{this.addMultipleStrings}}
          >
            {{t "plant.task.barcode.addOrString"}}
          </QuantitySelect>
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
